import { render, staticRenderFns } from "./kategori_servis.vue?vue&type=template&id=5171798e&"
import script from "./kategori_servis.vue?vue&type=script&lang=js&"
export * from "./kategori_servis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports